const delimiter = ' - '

const parseEntityName = (entity) => {
  if (!entity) return null
  return String(entity).split(delimiter)[0]
}

const parseEntityId = (entity) => {
  if (!entity) return null
  return String(entity).split(delimiter)[1]
}

const parseLocalidadName = (localidad) => {
  if (!localidad) return null
  return String(localidad).split(delimiter)[0]
}

const parseLocalidadCodigo = (localidad) => {
  if (!localidad) return null
  return String(localidad).split(delimiter)[1]
}

export {
  parseEntityName,
  parseEntityId,
  parseLocalidadName,
  parseLocalidadCodigo
}
